import { ANALYTICS_PLACEMENT } from "./constants";
import { ADVERTISE_NOW_CLICK_EVENT, pushDataLayer } from "../../../../utils/dataLayer";

type TrackAdvertiseNowClickParams = {
  propertyId?: number;
  placement?: string;
};

export function trackAdvertiseNowClick({
  propertyId,
  placement = ANALYTICS_PLACEMENT,
}: TrackAdvertiseNowClickParams = {}): void {
  pushDataLayer({
    event: ADVERTISE_NOW_CLICK_EVENT,
    property_id: propertyId ?? null,
    placement,
  });
}
